import { getUserGeoInfo } from 'dibs-regional-info/exports/regionalInfoHelpers';
import { FC, ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import { PdpSharedShippingInfo } from './PdpSharedShippingInfo';
import PdpSharedShippingCustomsDisclaimer from './PdpSharedShippingCustomsDisclaimer';

import styles from './PdpSharedShippingInfo.scss';

import { PdpSharedShippingInfoWrapper_item$key } from './__generated__/PdpSharedShippingInfoWrapper_item.graphql';
import { PdpSharedShippingInfoWrapper_user$key } from './__generated__/PdpSharedShippingInfoWrapper_user.graphql';

type Props = {
    item: PdpSharedShippingInfoWrapper_item$key;
    user: PdpSharedShippingInfoWrapper_user$key | null;
    currency: string;
    children?: ReactNode;
    leadTime?: string | null;
    renderTooltip?: boolean;
    showCustomsInfo?: boolean;
    isClient?: boolean;
    title?: ReactNode;
    displayInline?: boolean;
    preLinkQuoteDetails?: ReactNode;
    postLinkQuoteDetails?: ReactNode;
    postLinkNoQuoteDetails?: ReactNode;
    hidePaidShipping?: boolean;
    itemQuantity?: number | null;
};

const PdpSharedShippingInfoWrapper: FC<Props> = ({
    item: itemRef,
    user: userRef,
    currency,
    children,
    leadTime,
    renderTooltip,
    showCustomsInfo,
    isClient = false,
    title,
    displayInline,
    preLinkQuoteDetails,
    postLinkQuoteDetails,
    postLinkNoQuoteDetails,
    hidePaidShipping,
    itemQuantity,
}) => {
    const user = useFragment(
        graphql`
            fragment PdpSharedShippingInfoWrapper_user on User {
                serviceId
                isVerifiedTrade
            }
        `,
        userRef
    );
    const item = useFragment(
        graphql`
            fragment PdpSharedShippingInfoWrapper_item on Item {
                serviceId
                ...PdpSharedShippingCustomsDisclaimer_item
            }
        `,
        itemRef
    );

    const userGeoInfo = getUserGeoInfo();
    return (
        <span className={styles.shippingInfoContainer}>
            <PdpSharedShippingInfo
                renderTooltip={renderTooltip}
                currency={currency}
                leadTime={leadTime || ''}
                itemId={item.serviceId || ''}
                userId={user?.serviceId || ''}
                isTrade={user?.isVerifiedTrade || false}
                title={title}
                displayInline={displayInline}
                preLinkQuoteDetails={preLinkQuoteDetails}
                postLinkQuoteDetails={postLinkQuoteDetails}
                postLinkNoQuoteDetails={postLinkNoQuoteDetails}
                isClient={isClient}
                hidePaidShipping={hidePaidShipping}
                itemQuantity={itemQuantity}
                userZipCode={userGeoInfo?.zipCode}
                userCountryCode={userGeoInfo?.countryCode}
            />
            {children}
            {showCustomsInfo && (
                <PdpSharedShippingCustomsDisclaimer item={item} currency={currency} />
            )}
        </span>
    );
};

export default PdpSharedShippingInfoWrapper;
